export { default as ContactInfo } from './ContactInfo';
export { default as FooterBrand } from './FooterBrand';
export { default as FooterLinks } from './FooterLinks';
export { default as SocialMedia } from './SocialMedia';
export { default as DesktopFooter } from './DesktopFooter';
export { default as MobileFooter } from './MobileFooter';
